import { PageState } from "@mikros/library";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import {
  Grid,
  GridColumn,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface SearchOrgUserProps {
  searchUserState: Function;
  newUserState: Function;
  dataGridItemFunction: Function;
  adminUserData?: any;
  adminUserState?: Function;
  formTypeFunction: Function;
  phoneNumber?: any;
}

export function SearchOrgUser(props: SearchOrgUserProps) {
  const intl = useIntl();
  const initialDataState: PageState = { pageNumber: 1, skip: 0, take: 10 };
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [dataGrid, setDataGrid] = useState([]);

  console.log("data", dataGrid);
  console.log("admin user data", props?.adminUserData);
  console.log("phone number in searchorg user", props.phoneNumber);


  function convertRole(role: any) {
    switch (role) {
      case "tnt_superAdmin":
        return <FormattedMessage id="organization.superAdmin" />;
      case "tnt_contentCreator":
        return <FormattedMessage id="organization.contentCreator" />;
      case "tnt_reviewer":
        return <FormattedMessage id="organization.reviewer" />;
      case "tnt_admin":
        return <FormattedMessage id="organization.admin" />;
      case "tnt_L1Admin":
        return <FormattedMessage id="organization.l1Admin" />;
      case "tnt_courseScheduler":
        return <FormattedMessage id="organization.courseScheduler" />;
      case "tnt_auditor": 
        return <FormattedMessage id="organization.auditor" />;
    }
  }

  const handleGridItemClick = (data: any) => {
    console.log("inside handle grid item click function");
    console.log("click grid", data);
    props.searchUserState(false);
    props.newUserState(true);
    props.dataGridItemFunction(data);
    props.formTypeFunction(true);
  };

  useEffect(() => {
    setDataGrid(props?.adminUserData);
  }, [props?.adminUserData]);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    //@ts-ignore
    const take =
      targetEvent.value ===
      //  "All"
      intl.formatMessage({ id: "allValue" })
        ? dataGrid?.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }

    setPage((prevPage: any) => ({
      ...prevPage,
      ...event.page,
      take,
    }));
  };

  return (
    <div>
      <div className="mt-4">
        <Grid
          style={{ border: 0 }}
          rowHeight={48}
          data={dataGrid?.slice(page.skip, page.skip + page.take)}
          skip={page.skip}
          take={page.take}
          total={dataGrid?.length}
          onRowClick={handleGridItemClick}
          className="cursor-pointer custom-grid"
          pageable={{
            buttonCount: 4,
            pageSizes: [5, 10, 15, intl.formatMessage({ id: "allValue" })],
            pageSizeValue: pageSizeValue,
          }}
          onPageChange={pageChange}
        >
          <GridColumn
            field="fname"
            title={intl.formatMessage({ id: "searchOrgUser.firstName" })}
            cell={(props) => <td>{props.dataItem.fname}</td>}
          />
          <GridColumn
            field="lname"
            title={intl.formatMessage({ id: "searchOrgUser.lastName" })}
            cell={(props) => <td>{props.dataItem.lname}</td>}
          />

          <GridColumn
            field="phNo"
            title={intl.formatMessage({ id: "searchOrgUser.phNo" })}
            width="275px"
            cell={(props) => <td>{props.dataItem.phNo}</td>}
          />

          <GridColumn
            field="email"
            title={intl.formatMessage({ id: "searchOrgUser.email" })}
            cell={(props) => <td>{props.dataItem.email}</td>}
          />
          <GridColumn
            field="roleDesc"
            title={intl.formatMessage({ id: "searchOrgUser.access" })}
            cell={(props) => <td>{convertRole(props?.dataItem?.role)}</td>}
          />
          <GridColumn
            field="status"
            title={intl.formatMessage({ id: "searchOrgUser.status" })}
            cell={(props) => <td>{props.dataItem.status}</td>}
          />
        </Grid>
      </div>
    </div>
  );
}
